<template>

  <v-container fluid>
    <v-flex>
      <v-text-field
        v-for="(val, key) in returnItem"
        :label="key"
        :value="val"
        readonly
        :key="key"
      ></v-text-field>

      <v-btn @click="getPdf(returnItem.downloadPath)">get pdf</v-btn>

    </v-flex>
  </v-container>
</template>

<script>
  import AWS from 'aws-sdk';

  export default {

    data() {
      return {
        returnItem : {}
      }
    },
    created() {
      if(!profileConfig.labels || !profileConfig.labels.bucket) {
        throw new Error('fatal error: labels bucket not configured');
      }

      this.dataService.getReturn(this.$route.params.id).then(result => {
        console.log('getreturn ' , result.data);
        this.returnItem = result.data;
        delete this.returnItem.createdDate;
      });
    },

    methods: {
      getPdf(path) {
        const s3 = new AWS.S3()

        if(!profileConfig.labels || !profileConfig.labels.bucket) {
          throw new Error('fatal error: labels bucket not configured');
        }

        const params = {
          Bucket: profileConfig.labels.bucket,
          Key: path
        }

        s3.getSignedUrl('getObject', params, (err, url) => {
          if (err) {
            console.error('s3 error:', err)
            return
          }

          window.open(url);
        })
      }
    }

  }

</script>



// WEBPACK FOOTER //
// GetReturn.vue?bcb28cfa